import React from 'react';

import { OrdersOverviewCard } from '../orders-overview-card';
import { useOrdersOverview } from '../orders-overview-context/OrdersOverviewProvider';

export default function NumOrdersOverview() {
  const { trend, trendLastPeriod, totalTickets, totalTicketsLastPeriod } =
    useOrdersOverview();

  if (!totalTickets && !totalTicketsLastPeriod) {
    return null;
  }

  return (
    <OrdersOverviewCard
      amount={totalTickets}
      amountLastPeriod={totalTicketsLastPeriod}
      id="overview-num-orders"
      title="Number of orders"
      trendData={trend.map((data) => data.count)}
      trendDataCompare={trendLastPeriod.map((data) => data.count)}
    />
  );
}
